export class TreeUtils {
  // å¨ææ·»å styles
  public static addElStyles(el: any, styles: any) {
    if (styles instanceof Object) {
      for (const s in styles) {
        if (styles.hasOwnProperty(s)) {
          if (Array.isArray(styles[s])) {
            // ç¨äºæ¯æå¼å®¹æ¸é
            styles[s].forEach(val => {
              el.style[s] = val;
            });
          } else {
            el.style[s] = styles[s];
          }
        }
      }
    }
  }
}
